import MuiDialogActions from "@mui/material/DialogActions";

export default function DialogActions(props) {
  return <MuiDialogActions {...props} />;
}
